import { Component, OnInit } from '@angular/core';
import { ContenidoService } from '../contenido.service';

@Component({
  selector: 'app-az-accesories',
  templateUrl: './az-accesories.component.html',
  styleUrls: [
	'../../assets/css/bootstrap.min.css',
	'../../assets/scss/styles.scss', 
	'../../assets/scss/azamara.scss', 
	'../../assets/scss/fonts.scss',
	'./az-accesories.component.css',
	'../../assets/cssDali/general.scss'
	]
})
export class AzAccesoriesComponent implements OnInit {
  public contenido = this.contenidoService.getContenido("az-accesories");
  constructor(private contenidoService: ContenidoService) {}

  ngOnInit() {
  }

}
